"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// auth boot
const wrappers_1 = require("quasar/wrappers");
const auth_1 = require("../store/actions/auth");
// export default async ({ router: any, store: any }) => {
exports.default = wrappers_1.boot(async ({ router, store }) => {
    return new Promise((resolve) => {
        router.beforeEach(async (to, from, next) => {
            const isAuthenticated = store.getters['auth/isAuthenticated'];
            //const isAuthenticated = !!store.getters['auth/user'].id
            if ([
                // Allow below routes to be accessible without auth
                '/login',
                '/auth/register/author',
                '/auth/reset-password'
                // ---
            ].some((uri) => {
                return to.fullPath.includes(uri);
            })) {
                next();
            }
            else {
                if (!isAuthenticated) {
                    //
                    // NOT Authenticated
                    //
                    store.dispatch('auth/' + auth_1.AUTH_LOGOUT, {}).then(() => { }).catch(() => { }).then(async () => {
                        //if (!to.fullPath.startsWith('/login')) { // to access target view user must be authenticated - force to login first
                        await router.replace('/login' + (to.fullPath !== '/' ? '?to=' + encodeURIComponent(to.fullPath) : ''));
                        //} else { // target requested view is login - just show
                        //  next()
                        //}
                    });
                    // TODO: disable browser history browsing when user is not authenticated
                }
                else {
                    //
                    // Authenticated
                    //
                    if (!to.fullPath.startsWith('/login')) {
                        if (!from.query.to) { // go to target view
                            next();
                        }
                        else { // redirect to view attempted to reach before authentication
                            const to = from.query.to;
                            delete from.query.to; // or infinite loop
                            await router.replace({ path: to });
                        }
                    }
                    else { // requested view is login - do not show for authenticated user; view home page
                        //next(false)
                        await router.replace('/');
                    }
                }
            }
        });
        resolve();
    });
});
